// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import {
  SIMULADOR_FINANCIERO_DELETE_CUOTA,
} from './constants';

export function deleteCuota(id) {
  return {
    type: SIMULADOR_FINANCIERO_DELETE_CUOTA,
    id: id
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case SIMULADOR_FINANCIERO_DELETE_CUOTA:
      if (state.editLinea) {
        let editLineaData = state.editLineaData;
        editLineaData.datosFinancieros.cuotas.forEach((cuota) => {
          if (cuota.id === action.id && !cuota.newCuota) {
            editLineaData.datosFinancieros.cuotasDeleted.push({...cuota});
          }
        })
        let cuotas = state.editLineaData.datosFinancieros.cuotas.filter((value, index, arr) => {
          return value.id !== action.id;
        });
        editLineaData.datosFinancieros.cuotas = cuotas;
        
        return {
          ...state,
          editLineaData: editLineaData
        };
      } else {
        let altaNuevaLinea = state.altaNuevaLinea;
        let cuotas = state.altaNuevaLinea.datosFinancieros.cuotas.filter((value, index, arr) => {
          return value.id !== action.id;
        });
        altaNuevaLinea.datosFinancieros.cuotas = cuotas;
        
        return {
          ...state,
          altaNuevaLinea: altaNuevaLinea
        };
      }


    default:
      return state;
  }
}
